import { UseQueryOptions } from '@tanstack/react-query';

import { SMS } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import QueryKeys from './keys';

const useSms = (smsId: string, reactQueryOptions?: UseQueryOptions<SMS, Error>) =>
    useQuery<SMS>(QueryKeys.SMS_ID(smsId), new PathWithID(CuredApiPaths.SMS, Number(smsId)).url, reactQueryOptions);

export default useSms;
